import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useMutation } from "@tanstack/react-query"
import { ScanSearch } from "lucide-react"
import { useState } from "react"
import type { Company } from "./api"
import { openCompanyHarvest } from "./harvestBridge"
export function DiscoveryButton({ company }: { company: Company }) {
  const { translate: t } = useTranslation()
  const [url, setUrl] = useState(company.website)
  const start = useMutation({
    mutationFn: () => openCompanyHarvest(company.id, url),
  })
  return (
    <section className="rounded-xl border border-border bg-card p-5">
      <h2 className="font-semibold">{t("CI_FETCH")}</h2>
      <p className="my-2 text-sm text-muted-foreground">
        {t("CI_DISCOVERY_HINT")}
      </p>
      <form
        className="flex flex-wrap gap-3"
        onSubmit={(e) => {
          e.preventDefault()
          start.mutate()
        }}
      >
        <Input
          className="min-w-64 flex-1"
          aria-label={t("CI_DISCOVERY_URL")}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          type="url"
          pattern="https?://.*"
          maxLength={4096}
          required
        />
        <Button disabled={start.isPending} type="submit">
          <ScanSearch className="size-4" />
          {t("CI_FETCH")}
        </Button>
      </form>
      {start.isSuccess && (
        <p role="status" className="mt-3 text-sm">
          {t("CI_DISCOVERY_OPEN")}
        </p>
      )}
      {start.isError && (
        <p role="alert" className="mt-3 text-sm text-destructive">
          {start.error.message}
        </p>
      )}
    </section>
  )
}
